export default __webpack_public_path__ + "static/media/fad-logo-studioone.84d3d8fd.svg";